"use client";

import { useEffect } from "react";

// Pairs with the img/video user-select/drag reset in globals.css -- together they cover the
// three easy ways to save an image (drag-to-desktop, select-and-copy, right-click "Save
// image as..."). Scoped to just <img>/<video> targets via a single delegated listener rather
// than blocking the context menu everywhere, so right-click still works normally on text,
// links, and everything else on the site.
export default function ImageProtection() {
  useEffect(() => {
    function onContextMenu(e: MouseEvent) {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === "IMG" || target.tagName === "VIDEO")) {
        e.preventDefault();
      }
    }
    document.addEventListener("contextmenu", onContextMenu);
    return () => document.removeEventListener("contextmenu", onContextMenu);
  }, []);

  return null;
}
